<template>
  <el-row :span="20" style="color: white;">
    <el-col :span="8" style="text-align: left;font-size: 20px;margin-top: 17px">
      <span style="cursor: pointer;" @click="jumpCurrent">
        <img
          :src="logo"
          style="width: 25px;height: 25px;vertical-align: -5px;"
        />
        {{ $store.getters.getStorage.draw }}
      </span>
    </el-col>
    <el-col :span="8" style="text-align: center;margin-top: 10px;">
      <div>
        <el-row>
          <el-col :span="6">
            <el-button
              type="text"
              @click="guidance"
              style="font-size: 18px; color: blue;"
              >办事指南</el-button
            >
          </el-col>
          <el-col :span="6">
            <el-button
              type="text"
              @click="question"
              style="font-size: 18px; color: blue;"
              >常见问题</el-button
            >
          </el-col>
          <el-col :span="6">
            <el-button
              type="text"
              @click="video"
              style="font-size: 18px; color: blue;"
              >参考视频</el-button
            >
          </el-col>
          <el-col :span="6">
            <el-button
              type="text"
              @click="handbook"
              style="font-size: 18px; color: blue;"
              >参照手册</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-col>
    <el-col :span="8" style="text-align: right;margin-top: 14px;">
      <el-button
        icon="el-icon-back"
        plain
        circle
        @click="$router.go(-1)"
      ></el-button>
      <el-badge
        :value="$store.state.messageNumber"
        class="item"
        style="margin-right: 25px"
      >
        <el-button icon="el-icon-message" circle @click="inMessage"></el-button>
      </el-badge>
      <el-dropdown @command="handleCommand" style="cursor: pointer">
        <span class="el-dropdown-link" style="color: #fff;font-size: 20px">
          <template
            v-if="
              $store.getters.getStorage.user.user.roleName ===
                'constructioncorpemployee'
            "
          >
            {{ $store.getters.getStorage.user.user.username }}
          </template>
          <template v-else>
            {{ $store.getters.getStorage.user.user.orgName }}
          </template>
          <i class="el-icon-caret-bottom el-icon--right" />
        </span>
        <el-dropdown-menu slot="dropdown" style="width:150px">
          <el-dropdown-item command="ckaccount">切换账号</el-dropdown-item>
          <el-dropdown-item command="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-col>
  </el-row>
</template>
<script>
export default {
  data() {
    return {
      test: "1",
      city: this.$store.getters.getStorage.city,
      logo: require("../assets/js_logo.png"),
      url: {
        message: "/userinfo/notification/unread",
        jslogout: "/censor/logout",
        kcsjlogout: "/design/logout",
        stlogout: "/draw/logout"
      },
      logouturl: ""
    };
  },
  mounted() {
    this.query_config();
    document.querySelector("body").removeAttribute("style");
    document
      .querySelector("body")
      .setAttribute("style", "background-color:white");
    this.getMessage();
  },
  methods: {
    query_config() {
      var url = "/draw/sysFunctionsIntroduce";
      this.$http.get(url + "?code=city").then(res => {
        if (res.body.status === 200) {
          this.$store.commit("$_setCity", res.data.result.data[0].content);
        } else {
          this.$message.error("请配置城市");
        }
      });
    },
    jumpCurrent() {
      if (this.$store.getters.getStorage.draw === "建设单位网上报审") {
        this.$router.push("/constructionHome/HOME/censor");
      } else if (this.$store.getters.getStorage.draw === "设计单位网上报审") {
        this.$router.push("/designHome/HOME/design");
      } else if (this.$store.getters.getStorage.draw === "审查机构") {
        this.$router.push("/inspectDrawHome/HOME/draw");
      } else if (this.$store.getters.getStorage.draw === "监管机构") {
        this.$router.push("/inspectDrawHome/HOME/draw");
      }
    },
    inMessage() {
      let n = window.localStorage.isLogin,
        ura = "drawinMessage";
      switch (n) {
        case "100":
          ura = "conInMessage";
          break;
        case "200":
          ura = "designinMessage";
          break;
      }
      this.$router.push({ name: ura });
    },
    handleCommand(command) {
      this.city = this.$store.getters.getStorage.city;
      if (command == "logout") {
        if (this.$store.getters.getStorage.draw === "建设单位网上报审") {
          this.logouturl = this.url.jslogout;
        } else if (
          this.$store.getters.getStorage.draw === "勘察单位网上报审" ||
          this.$store.getters.getStorage.draw === "设计单位网上报审"
        ) {
          this.logouturl = this.url.kcsjlogout;
        } else if (this.$store.getters.getStorage.draw === "审查机构") {
          this.logouturl = this.url.stlogout;
        } else if (this.$store.getters.getStorage.draw === "监管机构") {
          this.logouturl = this.url.stlogout;
        }
        this.$http.get(this.logouturl).then(res => {
          if (res.data.status == 200) {
            console.log("退出成功");
          }
        });
        this.$message.success("退出登录，感谢您的使用");
        this.$store.commit("$_removeStorage");
        //这个需要配置下
        this.$router.push({ name: "Index" });
      } else if (command == "ckaccount" && this.city != "cf") {
        if (this.$store.getters.getStorage.draw === "建设单位网上报审") {
          this.$router.push({
            name: `censor_login` + (this.city != "" ? "-" + this.city : ""),
            query: { Type: "censor" }
          });
        } else if (this.$store.getters.getStorage.draw === "勘察单位网上报审") {
          this.$router.push({
            name: `censor_login` + (this.city != "" ? "-" + this.city : ""),
            query: { Type: "survey" }
          });
        } else if (this.$store.getters.getStorage.draw === "设计单位网上报审") {
          this.$router.push({
            name: `censor_login` + (this.city != "" ? "-" + this.city : ""),
            query: { Type: "design" }
          });
        } else if (this.$store.getters.getStorage.draw === "审查机构") {
          this.$router.push({
            name: `drawing_login` + (this.city != "" ? "-" + this.city : ""),
            query: { Type: "drawing" }
          });
        } else if (this.$store.getters.getStorage.draw === "监管机构") {
          this.$router.push({
            name: `drawing_login` + (this.city != "" ? "-" + this.city : ""),
            query: { Type: "supervise" }
          });
        } else {
          this.$router.push({ name: "Index" });
        }
        this.$message.success("切换账号，请重新登录");
        this.$store.commit("$_removeStorage");
      } else if (command == "ckaccount" && this.city == "cf") {
        if (this.$store.getters.getStorage.draw === "建设单位网上报审") {
          this.$router.push({
            name: `censor_login`,
            query: { Type: "censor" }
          });
        } else if (this.$store.getters.getStorage.draw === "勘察单位网上报审") {
          this.$router.push({
            name: `survey_login`,
            query: { Type: "survey" }
          });
        } else if (this.$store.getters.getStorage.draw === "设计单位网上报审") {
          this.$router.push({
            name: `design_login`,
            query: { Type: "design" }
          });
        } else if (this.$store.getters.getStorage.draw === "审查机构") {
          this.$router.push({
            name: `drawing_login`,
            query: { Type: "drawing" }
          });
        } else if (this.$store.getters.getStorage.draw === "监管中心") {
          this.$router.push({
            name: `supervise_login`,
            query: { Type: "supervise" }
          });
        } else {
          this.$router.push({ name: "Index" });
        }
        this.$message.success("切换账号，请重新登录");
        this.$store.commit("$_removeStorage");
      }
    },
    getMessage() {
      let n = window.localStorage.isLogin,
        ura = "/draw";
      switch (n) {
        case "100":
          ura = "/censor";
          break;
        case "200":
          ura = "/design";
          break;
      }
      let url = ura + this.url.message;
      this.$http.get(url).then(res => {
        if (res.body.status == 200)
          if (res.body.result != 0) {
            this.$notify.success({
              title: "提示",
              message:
                '<div style="font-size: 20px;"><br/>您有 <br/><br/><div style="font-size: 30px;color: red">' +
                res.body.result +
                "</div><br/>条消息待处理</div>",
              duration: 10000,
              dangerouslyUseHTMLString: true,
              position: "bottom-right"
            });
          }
        this.$store.state.messageNumber = res.body.result;
      });
    },
    backHome() {
      let n = window.localStorage.isLogin,
        ura = "/inspectDraw/indexOne";
      switch (n) {
        case "100":
          ura = "/constructionHome/HOME/censor";
          break;
        case "200":
          ura = "/designHome/HOME/design";
          break;
      }
      this.$router.push(ura);
    },
    guidance() {
      let routeUrl = this.$router.resolve({
        path: "/guidance"
      });
      window.open(routeUrl.href, "_blank");
    },
    question() {
      let routeUrl = this.$router.resolve({
        path: "/question"
      });
      window.open(routeUrl.href, "_blank");
    },
    video() {
      let routeUrl = this.$router.resolve({
        path: "/video"
      });
      window.open(routeUrl.href, "_blank");
    },
    handbook() {
      let routeUrl = this.$router.resolve({
        path: "/handbook"
      });
      window.open(routeUrl.href, "_blank");
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Header.vue